// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'battery-solid';

export const Component = () => (
  <path d='M23.038 8.927h-.48V6.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 21.072 5H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 6.485v10.776c0 .431.144.766.431 1.054.288.287.623.431 1.054.431h19.588c.432 0 .767-.144 1.054-.431.288-.288.432-.623.432-1.054v-2.442h.479c.43 0 .766-.144 1.053-.432.288-.287.432-.622.432-1.053v-2.97a1.9 1.9 0 0 0-.432-1.005 1.408 1.408 0 0 0-1.053-.432Z' />
);

export const viewBox = '0 0 25 25';
